/*** HEADER ***/
const header = document.querySelector('header');
if (header) {
  // toggle menu button per aprire e chiudere menu
  const toggleMenuButtons = header.querySelectorAll('.toggle-menu-button');
  const openMenuButton = header.querySelector('.toggle-menu-button:not(.close-menu-button)');
  const headerTopWrapper = header.querySelector('.header-top-wrapper');
  const closeMenuButton = header.querySelector('.close-menu-button');
  const mainDrawer = header.querySelector('#main-drawer');
  const isMenuOpen = () => header.classList.contains('open');

  const setMenuOpen = (isOpen) => {
    header.classList.toggle('open', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : 'auto';
    document.body.classList.toggle('h-screen', isOpen);
    if (openMenuButton) {
      openMenuButton.setAttribute('aria-expanded', isOpen.toString());
    }
    if (isOpen) {
      headerTopWrapper.setAttribute('inert', '');
      headerTopWrapper.setAttribute('aria-hidden', 'true');
      if (mainDrawer) {
        mainDrawer.removeAttribute('inert');
        mainDrawer.removeAttribute('aria-hidden');
      }
      if (closeMenuButton) closeMenuButton.focus();
    } else {
      headerTopWrapper.removeAttribute('inert');
      headerTopWrapper.removeAttribute('aria-hidden');
      if (mainDrawer) {
        mainDrawer.setAttribute('inert', '');
        mainDrawer.setAttribute('aria-hidden', 'true');
      }
      resetMenuAtClose();
      if (openMenuButton) openMenuButton.focus();
    }
  };

  const closeMenu = () => {
    if (isMenuOpen()) setMenuOpen(false);
  };

  toggleMenuButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      setMenuOpen(!isMenuOpen());
    });
  });

  // click fuori: #main-drawer è il backdrop a tutto schermo, quindi è "fuori"
  // tutto ciò che non finisce dentro .main-drawer-content. I cassetti di secondo
  // livello nel DOM stanno dentro il pannello (anche se a schermo escono a
  // destra), quindi un click al loro interno non chiude il menu.
  if (mainDrawer) {
    mainDrawer.addEventListener('click', function (e) {
      if (!isMenuOpen()) return;
      if (e.target.closest('.main-drawer-content')) return;
      closeMenu();
    });
  }
  // scrolltrigger per bg gradient header
  const headerGradient = document.querySelector('#header-gradient');
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: header,
      start: 'top top',
      end: 'top -=100px',
      scrub: 1,
      onLeave: () => {
        header.classList.add('white-header');
      },
      onLeaveBack: () => {
        header.classList.remove('white-header');
      }
    }
  });
  tl
    .to(headerGradient, {
      opacity: 1,
    });

  // first level links per aprire cassetti secondo e terzo livello
  const firstLevelLinksWrapper = document.querySelector('.first-level-links-wrapper');
  const firstLevelLinks = document.querySelectorAll('.first-level-link');
  const setDrawerInert = (linkRow, inert) => {
    const drawer = linkRow.querySelector('.content-drawer');
    if (!drawer) return;
    if (inert) {
      drawer.setAttribute('inert', '');
      drawer.setAttribute('aria-hidden', 'true');
    } else {
      drawer.removeAttribute('inert');
      drawer.removeAttribute('aria-hidden');
    }
  };

  const closeActiveDrawer = () => {
    let previousActive = firstLevelLinksWrapper.querySelector('.link-row.active');
    if (!previousActive) return;
    previousActive.classList.remove('active');
    setDrawerInert(previousActive, true);
    const prevButton = previousActive.querySelector('.first-level-link[aria-expanded]');
    if (prevButton) prevButton.setAttribute('aria-expanded', 'false');
    firstLevelLinksWrapper.classList.remove('has-active');
  };

  // Chiude il cassetto aperto riportando il focus sul link di primo livello che
  // lo aveva aperto. Torna false se non c'era nessun cassetto aperto.
  const closeActiveDrawerAndFocusTrigger = () => {
    if (!firstLevelLinksWrapper) return false;
    const linkRow = firstLevelLinksWrapper.querySelector('.link-row.active');
    if (!linkRow) return false;
    const btn = linkRow.querySelector('.first-level-link[aria-expanded]');
    closeActiveDrawer();
    if (btn) btn.focus();
    return true;
  };

  firstLevelLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      closeActiveDrawer();
      link.parentNode.classList.toggle('active');
      const isActive = link.parentNode.classList.contains('active');
      setDrawerInert(link.parentNode, !isActive);
      if (link.hasAttribute('aria-expanded')) {
        link.setAttribute('aria-expanded', isActive.toString());
      }
      let hasActive = firstLevelLinksWrapper.querySelector('.link-row.active');
      firstLevelLinksWrapper.classList.toggle('has-active', !!hasActive);
    });
  });

  document.querySelectorAll('.content-drawer').forEach(function (drawer) {
    drawer.addEventListener('focusout', function (e) {
      if (!drawer.contains(e.relatedTarget)) {
        const linkRow = drawer.closest('.link-row');
        if (linkRow && linkRow.classList.contains('active')) {
          linkRow.classList.remove('active');
          setDrawerInert(linkRow, true);
          const btn = linkRow.querySelector('.first-level-link[aria-expanded]');
          if (btn) btn.setAttribute('aria-expanded', 'false');
          firstLevelLinksWrapper.classList.remove('has-active');
        }
      }
    });
  });

  // second level back per chiudere cassetti secondo e terzo livello da mobile
  const secondLevelBack = document.querySelectorAll('.second-level-back');
  secondLevelBack.forEach(function (back) {
    back.addEventListener('click', function (e) {
      if (window.innerWidth < 1024) {
        closeActiveDrawerAndFocusTrigger();
      }
    });
  });

  //reset at close menu
  const resetMenuAtClose = () => {
    closeActiveDrawer();
  }

  // modal toggle button
  const modalToggleButtons = document.querySelectorAll('.modal-toggle-button');
  const modalCloseButtons = document.querySelectorAll('.modal-close-button');
  let selectedModal = null;
  let activeModalTrigger = null;

  const setModalInert = (modal, inert) => {
    if (!modal) return;
    if (inert) {
      modal.setAttribute('inert', '');
      modal.setAttribute('aria-hidden', 'true');
    } else {
      modal.removeAttribute('inert');
      modal.removeAttribute('aria-hidden');
    }
  };

  const getModalFocusable = (modal) => {
    if (!modal) return [];
    return Array.from(
      modal.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );
  };

  const trapModalFocus = (e) => {
    if (!selectedModal || e.key !== 'Tab') return;
    const focusable = getModalFocusable(selectedModal);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  let modalLockedBody = false;

  const lockModalBody = () => {
    if (window.innerWidth >= 1024) return;
    document.body.style.overflow = 'hidden';
    modalLockedBody = true;
  };

  const unlockModalBody = () => {
    if (!modalLockedBody) return;
    document.body.style.overflow = '';
    modalLockedBody = false;
  };

  const closeModal = () => {
    if (selectedModal) {
      selectedModal.classList.remove('open');
      setModalInert(selectedModal, true);
      unlockModalBody();
      if (activeModalTrigger) {
        activeModalTrigger.setAttribute('aria-expanded', 'false');
        activeModalTrigger.focus();
        activeModalTrigger = null;
      }
      selectedModal = null;
    }
  };
  modalToggleButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      selectedModal = document.querySelector(`[data-modal="${button.id}"]`);
      selectedModal.classList.add('open');
      setModalInert(selectedModal, false);
      lockModalBody();
      button.setAttribute('aria-expanded', 'true');
      activeModalTrigger = button;
      const closeButton = selectedModal.querySelector('.modal-close-button');
      const focusable = getModalFocusable(selectedModal);
      const focusTarget = closeButton || focusable[0];
      if (focusTarget) focusTarget.focus();
    });
  });
  modalCloseButtons.forEach(function (button) {
    button.addEventListener('click', closeModal);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (selectedModal) {
        closeModal();
      } else if (isMenuOpen()) {
        // Con un cassetto aperto Esc riporta al primo livello, altrimenti chiude
        // il menu e resetta tutto.
        if (!closeActiveDrawerAndFocusTrigger()) closeMenu();
      }
    }
    trapModalFocus(e);
  });
}